export type MunicipalityCollaborator = {
  id: number;
  email: string;
};

// departmentId narrows the list to that department's members. Roles on a
// department-scoped opportunity must be department members (ENG-1824), so the
// pickers pass it and only ever offer people who will validate.
export async function listMunicipalityCollaborators(
  municipalityId: number,
  departmentId?: number | null,
): Promise<MunicipalityCollaborator[]> {
  const query = departmentId == null ? "" : `?department_id=${departmentId}`;
  const response = await fetch(
    `/api/v1/municipalities/${municipalityId}/collaborators${query}`,
    {
      credentials: "include",
      headers: { Accept: "application/json" },
    },
  );
  if (!response.ok) {
    throw new Error("Failed to load collaborators");
  }
  return response.json();
}
